import { toast } from 'sonner';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import api from '../api';

function AdminLandingSettings() {
  const { t, i18n } = useTranslation();
  const [settings, setSettings] = useState({
    video1_url: '',
    video1_title_ca: "Per què invertir amb Vivendius?",
    video1_title_es: "¿Por qué invertir con Vivendius?",
    video2_url: '',
    video2_title_ca: "Com funciona el club d'inversors?",
    video2_title_es: "¿Cómo funciona el club de inversores?",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const resp = await api.get('/api/public/landing-settings');
      setSettings(prev => ({ ...prev, ...resp.data }));
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/api/admin/landing-settings', settings);
      toast.success(i18n.language === 'ca' ? 'Configuració guardada' : 'Configuración guardada');
    } catch (error) {
      toast.error('Error');
    } finally {
      setSaving(false);
    }
  };

  const extractYouTubeId = (url) => {
    if (!url) return null;
    const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };

  const inputStyle = {
    width: '100%', padding: '0.75rem', background: 'rgba(255,255,255,0.06)',
    border: '1.5px solid rgba(255,255,255,0.15)', borderRadius: '10px',
    color: 'white', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box'
  };

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="content-area">
        <TopBar title={i18n.language === 'ca' ? 'Configuració Landing' : 'Configuración Landing'} />
        <main style={{ padding: '1.5rem', maxWidth: '800px' }}>

          {[1, 2].map(n => {
            const url = settings[`video${n}_url`];
            const ytId = extractYouTubeId(url);
            return (
              <div key={n} className="dark-card" style={{ padding: '1.5rem', marginBottom: '1.5rem' }}>
                <h3 style={{ color: 'white', fontSize: '1.1rem', marginBottom: '1rem' }}>
                  {i18n.language === 'ca' ? `Vídeo ${n}` : `Video ${n}`}
                </h3>

                <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginBottom: '0.3rem' }}>URL YouTube</label>
                <input
                  value={url}
                  onChange={(e) => setSettings({ ...settings, [`video${n}_url`]: e.target.value })}
                  style={inputStyle}
                  placeholder="https://www.youtube.com/watch?v=..."
                />

                {/* Preview */}
                {ytId && (
                  <div style={{ marginTop: '0.75rem', borderRadius: '10px', overflow: 'hidden' }}>
                    <iframe
                      width="100%" height="220"
                      src={`https://www.youtube.com/embed/${ytId}`}
                      title={`Video ${n}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: '10px' }}
                    />
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                  <div>
                    <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginBottom: '0.3rem' }}>Títol (Català)</label>
                    <input
                      value={settings[`video${n}_title_ca`]}
                      onChange={(e) => setSettings({ ...settings, [`video${n}_title_ca`]: e.target.value })}
                      style={inputStyle}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginBottom: '0.3rem' }}>Título (Español)</label>
                    <input
                      value={settings[`video${n}_title_es`]}
                      onChange={(e) => setSettings({ ...settings, [`video${n}_title_es`]: e.target.value })}
                      style={inputStyle}
                    />
                  </div>
                </div>
              </div>
            );
          })}

          <button onClick={handleSave} disabled={saving} style={{
            padding: '0.875rem 2rem', background: 'linear-gradient(135deg, #103766, #1a5276)',
            color: 'white', border: 'none', borderRadius: '10px', fontWeight: '600',
            fontSize: '1rem', cursor: saving ? 'not-allowed' : 'pointer', width: '100%'
          }}>
            {saving ? '...' : (i18n.language === 'ca' ? 'Guardar Configuració' : 'Guardar Configuración')}
          </button>
        </main>
      </div>
    </div>
  );
}

export default AdminLandingSettings;
